import { reactive, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default function useUrlQuery() {
  const route = useRoute();
  const router = useRouter();
  const state = reactive({});

  const toQuery = (source) => {
    const query = {};
    Object.keys(source).forEach((key) => {
      const value = source[key];
      if (value === null || value === undefined || value === '') return;
      if (Array.isArray(value) && value.length === 0) return;
      query[key] = value;
    });
    return query;
  };

  const serialize = (source) => {
    const params = new URLSearchParams();
    Object.keys(source)
      .sort()
      .forEach((key) => {
        const value = source[key];
        (Array.isArray(value) ? value : [value]).forEach((entry) => params.append(key, entry));
      });
    return params.toString();
  };

  const readFromRoute = () => {
    const query = route.query;
    Object.keys(state).forEach((key) => {
      if (!(key in query)) Reflect.deleteProperty(state, key);
    });
    Object.assign(state, query);
  };

  readFromRoute();
  watch(() => route.query, readFromRoute, { deep: true });

  watch(
    state,
    () => {
      const query = toQuery(state);
      if (serialize(query) === serialize(toQuery(route.query))) return;
      router.replace({ query, hash: route.hash }).catch(() => {});
    },
    { deep: true },
  );

  return state;
}
